import {
  ThemedFunctor, TypographyName, getTypography,
} from '@doveit/bricks';
import { css } from 'styled-components';

export const basic: ThemedFunctor = ({ theme }) => css`
  ${getTypography(theme, TypographyName.BODY)}
  color: ${theme.palettes.brand.primary};
`;
